import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Cancel, List, Add, AddCircle, Edit } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import clsx from "clsx";
import { Grid, Tooltip, Box, Alert, Tabs, Tab } from "@mui/material";

import StatusAdmin from "views/dialog/StatusAdmin";
import EditProductAdmin from "views/dialog/EditProductAdmin";
import NewProductAdmin from "views/dialog/NewProductAdmin";
import CompaniesSelectAdmin from "views/dialog/CompaniesSelectAdmin";

import backgroundImage from "assets/img/backgroundProduct.jpg";
import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ProductsListAdmin() {
  const classes = useStyles();
  const [rows, setRows] = useState(null);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [idRow, setIdRow] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openNew, setopenNew] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openCompanies, setOpenCompanies] = useState(false);
  const [valueTab, setValueTab] = React.useState(0);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const [state] = useState({
    columns: [
      {
        headerName: "-----",
        field: "image",
        width: 80,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <img
              src={backgroundImage}
              alt="foto"
              style={{
                width: 60,
                objectFit: "cover",
                margin: "12px 0",
                borderRadius: 4,
              }}
            />
          );
        },
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Producto",
        field: "name",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      /*{
        headerName: "Precio",
        field: "price",
        width: 120,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>${params.value}</b>;
        },
        sortable: false,
        hideable: false,
      },*/
      {
        headerName: "IVA",
        field: "selectIVA",
        width: 80,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <b style={{ fontSize: 12 }}>{params.value === 1 ? "SI" : "NO"}</b>
          );
        },
        sortable: false,
        hideable: false,
      },
      {
        field: "action1",
        headerName: "----",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 100,
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewsCompanyValue(params)}
            style={{ margin: "12px 0" }}
          >
            Empresas
          </ButtonTableGrid1>
        ),
      },
      {
        field: "cert",
        headerName: "Ejemplo",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 100,
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewCertHidenValue(params)}
            style={{ margin: "12px 0", background: "green" }}
          >
            Certificado
          </ButtonTableGrid1>
        ),
      },
      {
        headerName: "Estado",
        field: "status",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text = params.value === 1 ? "ACTIVO" : "INACTIVO";
          const color = params.value === 1 ? "green" : "red";
          return (
            <>
              <b style={{ color: color, fontSize: 10 }}>{text}</b>
            </>
          );
        },
        align: "center",
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 110,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Editar" arrow>
                  <Edit style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Editar"
              onClick={openEditValue(params)}
            />
          );

          if (parseInt(params.row.status) === 0) {
            // Si el perfil está deshabilitado, mostramos el icono para habilitarlo
            actions.push(
              <GridActionsCellItem
                key="enable"
                icon={
                  <Tooltip title="Habilitar" arrow>
                    <AddCircle style={{ fontSize: 24, color: "green" }} />
                  </Tooltip>
                }
                label="Habilitar"
                onClick={openStatusValue(params)}
              />
            );
          } else {
            // Si el perfil está habilitado, mostramos el icono para deshabilitarlo
            actions.push(
              <GridActionsCellItem
                key="disable"
                icon={
                  <Tooltip title="Deshabilitar" arrow>
                    <Cancel style={{ fontSize: 24, color: "#000" }} />
                  </Tooltip>
                }
                label="Deshabilitar"
                onClick={openStatusValue(params)}
              />
            );
          }

          return actions;
        },
      },
    ],
  });

  const [state2] = useState({
    columns2: [
      {
        headerName: "-----",
        field: "image",
        width: 80,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <img
              src={backgroundImage}
              alt="foto"
              style={{
                width: 60,
                objectFit: "cover",
                margin: "12px 0",
                borderRadius: 4,
              }}
            />
          );
        },
        cellClassName: (params) => clsx("super-app", { celAll: params.value }),
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Producto",
        field: "name",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        field: "company",
        headerName: "Empresa",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 100,
        align: "center",
        renderCell: (params) => {
          return (
            <>
              <b style={{ fontSize: 12 }}>POINT</b>
            </>
          );
        },
      },
      {
        field: "cert",
        headerName: "Ejemplo",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 100,
        renderCell: (params) => {
          const data = { row: { id: params.row.id, name: params.row.name } };
          return (
            <ButtonTableGrid1
              onClick={openViewCertHidenValue(data)}
              style={{ margin: "12px 0", background: "green" }}
            >
              Certificado
            </ButtonTableGrid1>
          );
        },
      },
      {
        headerName: "Estado",
        field: "status",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text = "ACTIVO";
          const color = "green";
          return (
            <>
              <b style={{ color: color, fontSize: 10 }}>{text}</b>
            </>
          );
        },
        align: "center",
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  const RefreshTable = async () => {
    try {
      const response = await axios.get(`${urlServices}products/list`, {
        headers: {
          Authorization: `Bearer ${keyAuthorization}`,
        },
      });

      if (response.status === 200) {
        const transformedRows = response.data.map((data) => ({
          ...data,
          prices: parseJsonArray(data.prices),
        }));

        setRows(transformedRows);
      }
    } catch (e) {
      handleError(e);
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const handleError = (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 404:
          setRows(null);
          break;
        case 401:
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);
          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
          break;
        case 500:
          setMensageSystem("Error en la consulta con el servidor.");
          setError(true);
          break;
        default:
          setMensageSystem("Ha ocurrido un error inesperado.");
          setError(true);
      }
    } else {
      setMensageSystem("Error de conexión. Por favor, inténtelo más tarde.");
      setError(true);
    }
  };

  const handleCloseStatus = () => {
    setOpenStatus(false);
  };

  const openViewsCompanyValue = (data) => () => {
    setIdRow(data);
    setOpenCompanies(true);
  };

  const handleCloseViewCompanies = () => {
    setOpenCompanies(false);
  };

  const handleCloseNew = () => {
    setopenNew(false);
  };

  const openStatusValue = (data) => () => {
    setIdRow(data);
    setOpenStatus(true);
  };

  const openViewCertHidenValue = (data) => async () => {
    let pdfUrl = "";
    setError(false);

    const formData = {
      data: data.row,
    };

    try {
      const response = await axios.post(
        `${urlServices}payment-transaction/certificate-product`,
        formData
      );

      if (response.status === 200) {
        pdfUrl = `${urlServices}documents/${response.data.pdf}`;
        window.open(pdfUrl, "_blank"); // Abrir en nueva pestaña
      }
    } catch (e) {
      handleError(e);
    }
  };

  const openEditValue = (data) => () => {
    setIdRow(data.row);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const rowsHiden = [
    {
      id: 101,
      image: "",
      name: "POINT ASISTENCIA",
      company: "",
      cert: "",
      status: "",
    },
  ];

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <List className={classes.iconFilter} /> Listado de productos
        </div>
        <Card>
          <CardBody>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ width: "100%" }}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                          value={valueTab}
                          onChange={handleChangeTab}
                          aria-label="basic tabs example"
                        >
                          <Tab
                            sx={{ background: "#F8F8F8", color: "#000" }}
                            label="Productos del sistema"
                            {...a11yProps(0)}
                          />
                          <Tab
                            sx={{ background: "#F8F8F8", color: "#000" }}
                            label="Productos personalizados ocultos"
                            {...a11yProps(1)}
                          />
                        </Tabs>
                      </Box>
                      <CustomTabPanel value={valueTab} index={0}>
                        <Grid container>
                          <Grid item xs={12} sm={12}>
                            <div style={{ float: "right" }}>
                              <ButtonStyle0
                                onClick={(event) => {
                                  setopenNew(true);
                                }}
                                endIcon={<Add />}
                              >
                                Agregar producto
                              </ButtonStyle0>
                            </div>
                          </Grid>
                          {rows.length > 0 ? (
                            <Grid item xs={12} sm={12}>
                              <Box
                                sx={{
                                  "& .super-app.celAll": {
                                    fontSize: 12,
                                    //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                                  },
                                  "& .super-app.celActions": {
                                    backgroundColor: "rgb(242, 242, 242)",
                                  },
                                  "& .super-app-theme--header": {
                                    backgroundColor: "rgb(242, 242, 242)",
                                  },
                                  marginTop: 2,
                                }}
                              >
                                <DataGrid
                                  rows={rows}
                                  columns={state.columns}
                                  loading={loader}
                                  initialState={{
                                    pagination: {
                                      paginationModel: {
                                        page: 0,
                                        pageSize: 10,
                                      },
                                    },
                                  }}
                                  pageSizeOptions={[5, 10, 20, 50]}
                                  disableRowSelectionOnClick={true}
                                  checkboxSelection={false}
                                  sx={{
                                    [`& .${gridClasses.cell}`]: {
                                      display: "flex",
                                      alignItems: "center", // Alineación vertical
                                      // justifyContent: 'center', // Alineación horizontal
                                      //wordWrap: 'break-word !important',
                                      //whiteSpace: 'normal !important',
                                    },
                                    /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                                  }}
                                  getRowHeight={() => "auto"}
                                  // autoHeights
                                  autoWidth
                                />
                              </Box>
                            </Grid>
                          ) : (
                            <Grid item xs={12} sm={12}>
                              <center>
                                <img
                                  alt="loaderGif"
                                  src={noDataImg}
                                  style={{ width: 300, marginTop: 50 }}
                                />
                                <br></br>
                                <b
                                  style={{
                                    fontSize: 18,
                                    margin: "5px 0 70px 0",
                                  }}
                                >
                                  No hay registros para mostrar
                                </b>
                              </center>
                            </Grid>
                          )}
                        </Grid>
                      </CustomTabPanel>
                      <CustomTabPanel value={valueTab} index={1}>
                        <Grid container>
                          {rowsHiden.length > 0 ? (
                            <Grid item xs={12} sm={12}>
                              <Box
                                sx={{
                                  "& .super-app.celAll": {
                                    fontSize: 12,
                                    //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                                  },
                                  "& .super-app.celActions": {
                                    backgroundColor: "rgb(242, 242, 242)",
                                  },
                                  "& .super-app-theme--header": {
                                    backgroundColor: "rgb(242, 242, 242)",
                                  },
                                  marginTop: 2,
                                }}
                              >
                                <DataGrid
                                  rows={rowsHiden}
                                  columns={state2.columns2}
                                  initialState={{
                                    pagination: {
                                      paginationModel: {
                                        page: 0,
                                        pageSize: 10,
                                      },
                                    },
                                  }}
                                  pageSizeOptions={[5, 10, 20, 50]}
                                  disableRowSelectionOnClick={true}
                                  checkboxSelection={false}
                                  sx={{
                                    [`& .${gridClasses.cell}`]: {
                                      display: "flex",
                                      alignItems: "center", // Alineación vertical
                                      // justifyContent: 'center', // Alineación horizontal
                                      //wordWrap: 'break-word !important',
                                      //whiteSpace: 'normal !important',
                                    },
                                    /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                                  }}
                                  getRowHeight={() => "auto"}
                                  // autoHeights
                                  autoWidth
                                />
                              </Box>
                            </Grid>
                          ) : (
                            <Grid item xs={12} sm={12}>
                              <center>
                                <img
                                  alt="loaderGif"
                                  src={noDataImg}
                                  style={{ width: 300, marginTop: 50 }}
                                />
                                <br></br>
                                <b
                                  style={{
                                    fontSize: 18,
                                    margin: "5px 0 70px 0",
                                  }}
                                >
                                  No hay registros para mostrar
                                </b>
                              </center>
                            </Grid>
                          )}
                        </Grid>
                      </CustomTabPanel>
                      <CustomTabPanel value={valueTab} index={2}>
                        Item Three
                      </CustomTabPanel>
                    </Box>
                  </Grid>
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openStatus && (
        <StatusAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="products"
        />
      )}
      {openNew && (
        <NewProductAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openEdit && (
        <EditProductAdmin
          open={openEdit}
          exit={handleCloseEdit}
          callBackRefresh={RefreshTable}
          idRow={idRow}
        />
      )}
      {openCompanies && (
        <CompaniesSelectAdmin
          open={openCompanies}
          exit={handleCloseViewCompanies}
          callBackRefresh={RefreshTable}
          idRow={idRow}
        />
      )}
    </GridContainer>
  );
}
